import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent
} from '@material-ui/core';
import {
  Build as BuildIcon
} from '@material-ui/icons';
import { withCleanProps } from '../utils/cleanProps.jsx';
import { useStyles } from '../styles.jsx';

// Versões limpas dos componentes Material-UI
const CleanBox = withCleanProps(Box);
const CleanTypography = withCleanProps(Typography);
const CleanCard = withCleanProps(Card);
const CleanCardContent = withCleanProps(CardContent);

/**
 * Componente que exibe a tela de modo manutenção
 */
const MaintenanceScreen = ({ 
  healthData, 
  lastCheck
}) => {
  
  // Usar restaurante do localStorage para manter consistência visual
  const [restaurante, setRestaurante] = React.useState({});
  const styles = useStyles(restaurante);

  React.useEffect(() => {
    const cache = localStorage.getItem('restaurante');
    if (cache) {
      setRestaurante(JSON.parse(cache));
    }
  }, []);

  return (
    <CleanBox className={`${styles.root} ${styles.navy}`}>
      <CleanBox
        className={`${styles.main} ${styles.center}`}
        style={{ 
          padding: '32px 0',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center'
        }}
      >
        {/* Ícone principal */}
        <BuildIcon 
          style={{ 
            fontSize: 120, 
            color: 'white',
            marginBottom: 32,
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))'
          }} 
        />
        
        {/* Título principal */}
        <CleanTypography
          variant="h1"
          component="h1"
          style={{
            marginBottom: 24,
            color: 'white',
            textShadow: '0 3px 10px rgba(0,0,0,0.3)',
            fontSize: '4rem',
            fontWeight: 'bold',
            letterSpacing: '1px'
          }}
        >
          TOTEM EM MANUTENÇÃO
        </CleanTypography>

        {/* Card com mensagem */}
        <CleanCard 
          className={styles.card}
          style={{
            maxWidth: 600,
            margin: '32px auto',
            borderRadius: 24,
            overflow: 'hidden',
            boxShadow: '0 12px 24px rgba(0,0,0,0.2)',
          }}
        >
          <CleanCardContent style={{ padding: 48 }}>
            <CleanTypography
              variant="h4"
              component="h2"
              style={{
                marginBottom: 24,
                color: '#333',
                fontWeight: 'bold',
                fontSize: '2.2rem',
                textAlign: 'center'
              }}
            >
              Totem Temporariamente Indisponível
            </CleanTypography>
            
            <CleanTypography
              variant="body1"
              style={{
                fontSize: '1.6rem',
                color: '#666',
                textAlign: 'center',
                lineHeight: 1.6
              }}
            >
              Estamos realizando manutenção em nossos serviços.
              <br />
              Por favor, faça o pedido diretamente na loja.
            </CleanTypography>
          </CleanCardContent>
        </CleanCard>

        {/* Mensagem de agradecimento */}
        <CleanTypography
          variant="h3"
          style={{
            marginTop: 32,
            color: 'white',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)',
            fontSize: '2rem',
            fontWeight: 'normal'
          }}
        >
          Obrigado pela compreensão!
        </CleanTypography>
      </CleanBox>
    </CleanBox>
  );
};

export default MaintenanceScreen;
